
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/random-coffee/alternatives/shuffl",
      function () {
        return require("private-next-pages/random-coffee/alternatives/shuffl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/random-coffee/alternatives/shuffl"])
      });
    }
  